import React from "react";
import HeroAbout from "../sections/HeroAbout";
import HospitalName from "../sections/HospitalName";
import Comment from "../sections/Comment";
import Doctors from "../sections/Doctors";
import News from "../sections/News";
import Contact from "../sections/Contact";

const AboutUs = () => {
  return (
    <div>
      <HeroAbout />
      <HospitalName />
      <Comment />
      <Doctors />
      <News />
      <Contact />
    </div>
  );
};

export default AboutUs;
